import { controlToastState } from "risa-oasis-ui_v2";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../../api/firebase/references";

interface HandleRejectNarIngestionParams {
  documentId: string;
  setIsSubmitting?: (isSubmitting: boolean) => void;
}

export const handleRejectNarIngestion = async ({
  documentId,
  setIsSubmitting,
}: HandleRejectNarIngestionParams) => {
  try {
    if (setIsSubmitting) {
      setIsSubmitting(true);
    }

    await FirestoreService.updateDocument(
      FirestoreCollectionReference.narIngestionLogs(),
      documentId,
      {
        is_rejected: true,
      },
    );
    controlToastState("nar-ingestion-rejected-success");

    if (setIsSubmitting) {
      setIsSubmitting(false);
    }
  } catch (error) {
    controlToastState("nar-ingestion-rejected-failure");
    if (setIsSubmitting) {
      setIsSubmitting(false);
    }
  }
};
